import { FC } from 'react'

import { useFeatureFlag } from '../../../../../../app/_providers/ExperimentationProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { DetailsSectionSidePaddedSection } from '../../styles'

import { StyleLinkItem } from './StyleLinkItem'
import { Container } from './styles'
import { useTranslatedStyleLinks } from './useTranslatedStyleLinks'

type Props = {
  handle: string
}

export const StyleLinks: FC<Props> = ({ handle }) => {
  const styleLinks = useTranslatedStyleLinks()
  const flag = useFeatureFlag({
    key: 'pdp-other-styles-link',
    defaultVariant: 'false',
    ifAccessedPriorToDecisionInitialization: 'return-null-while-pending',
    skip: !Object.keys(styleLinks).includes(handle),
  })

  const {
    pages: {
      product: {
        styleLinks: { alsoAvailableInSingle },
      },
    },
  } = useTranslation()

  const otherStyles = styleLinks[handle]

  if (flag !== 'true' || !otherStyles) return null

  // Only handle single style case since all entries have exactly 1 alternative for now
  const style = otherStyles[0]!
  const parts = alsoAvailableInSingle.split('{{style}}')

  return (
    <DetailsSectionSidePaddedSection>
      <Container>
        {parts[0]}
        <StyleLinkItem title={style.title} handle={style.handle} />
      </Container>
    </DetailsSectionSidePaddedSection>
  )
}
